module.exports = __webpack_public_path__ + "img/G2AXtion-White.aee9e62a.svg";